import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/tempcar/bill/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/tempcar/bill/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/tempcar/bill/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/park/tempcar/bill/submit', params, options);

export const update = (params, options) =>
  request.post('/api/park/tempcar/bill/submit', params, options);
